import { observer } from 'mobx-react-lite'
import React from 'react'
import { Status } from 'shared/ui'
import { type IDiscoverBoxData } from 'pages/discover/lib/types'

type IBoxListCardProps = {
  box: IDiscoverBoxData
}

export const BoxListCardStatus = observer(({ box }: IBoxListCardProps) => {
  if (!box.redirectTo) {
    return <Status title='Coming soon' intent='white_label' emphasis='high' />
  }

  if (box.isActive) {
    return <Status title='Active' intent='positive' icon='check2' emphasis='high' />
  }

  if (box.isNew) {
    return <Status title={'New'} intent={'purple'} emphasis={'high'} size={'label'} />
  }

  return null
})
